import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=b3b644ca&scoped=true&lang=pug&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b644ca",
  null
  
)

export default component.exports